export default __webpack_public_path__ + "static/media/lamp1.b60b79d2.png";